export default {
  //通知
  ChatRoomMemberBlackAdd: 'ChatRoomMemberBlackAdd',
  chatRoomMemberIn: 'chatRoomMemberIn', // 房间进入
  ChatRoomTip: 'ChatRoomTip',
  kickoff: 'kickoff', // 退出
  notciefromsvr: 'notciefromsvr',
  chatRoomMemberExit: 'chatRoomMemberExit', // 房间退出
  ChatRoomInfoUpdated: 'ChatRoomInfoUpdated',
  ChatRoomMemberKicked: 'ChatRoomMemberKicked', // 被主播退出
  QueueMemberUpdateNotice: 'QueueMemberUpdateNotice', // 房间成员列表发生变化
  QueueMicUpdateNotice: 'QueueMicUpdateNotice', //麦位状态更新
  sendMessageReport: 'sendMessageReport',
  ChatRoomManagerAdd: 'ChatRoomManagerAdd', // 房间内设置管理员
  ChatRoomManagerRemove: 'ChatRoomManagerRemove', // 房间内移除管理员
  sendTextReport: 'sendTextReport',
  sendPublicMsgNotice: 'sendPublicMsgNotice',
  passmicNotice: 'passmicNotice',
  requestNoRoomUserNotice: 'requestNoRoomUserNotice',
  chatRoomMemberMute: 'ChatRoomMemberMute',
  chatRoomMemberMuteCancel: 'ChatRoomMemberMuteCancel',
  roomClientMicAgree: 'roomClientMicAgree',
  roomClientMicReject: 'roomClientMicReject',
  roomReceiveSum: 'roomReceiveSum', //视屏房收益通知

  sendUploadLogNotice: 'sendUploadLogNotice',
  roomClientMicApply: 'roomClientMicApply', //有嘉宾申请连麦
  roomClientMicCancel: 'roomClientMicCancel', //嘉宾取消连麦

  ChatRoomMemberWanMesg: 'ChatRoomMemberWanMesg', //发送警告给主播
  ChatRoomMemberBlock: 'ChatRoomMemberBlock', //直播封禁
  RoomForceOnLiveNotice: 'roomForceOnLiveNotice', //直播封禁

  pushUserExperienceUpdate: 'pushUserExperienceUpdate', // 用户等级更新

  // 魅力值PK
  sendPkInvite: 'sendPkInvite', // 发送魅力值pk邀请
  sendPkResult: 'sendPkResult', // 发送魅力值pk结果消息
  sendPkMsg: 'sendPkMsg', // 发送魅力值pk消息

  BarrageMessage: 'barrageMessage', //弹幕
  feeRoomGiftStatusChange: 'feeRoomGiftStatusChange', // 入场券模式状态通知
  feeRoomReceiveSum: 'feeRoomReceiveSum', // 入场券人数变化通知

  /**
   * 多人房房主邀请用户上麦
   */
  inviteToUser: 'inviteToUser',
  /**
   * 房间小时榜更新推送
   */
  roomHourCharmUpdate: 'roomHourCharmUpdate',

  /*-------------------- 爆弹相关的路由 ----------------------*/
  // 房间爆弹引爆
  roomRocketBlowUp: 'roomRocketBlowUp',
  // 房间爆弹礼物中奖
  roomRocketReward: 'roomRocketReward',
  // 房间爆弹清空
  roomRocketDel: 'roomRocketDel',
  // 房间爆弹流水推送
  roomRocketDiamond: 'roomRocketDiamond',
  /*---------------------- pk相关消息路由 ----------------------*/
  roomMatchPkReady: 'roomMatchPkReady',
  roomMatchPkAction: 'roomMatchPkAction',
  roomMatchPkScore: 'roomMatchPkScore',
  roomMatchPkResult: 'roomMatchPkResult',

  // pk邀请
  roomMatchPkInvite: 'roomMatchPkInvite',
  // PK邀请拒绝
  roomMatchPkReject: 'roomMatchPkReject',

  /*----------------------- 多人视频房路由 -----------------------*/

  multiRoomMicApply: 'multiRoomMicApply',
  multiRoomMicCancel: 'multiRoomMicCancel',
  multiRoomMicReject: 'multiRoomMicReject',
  multiRoomGiftDiamond: 'multiRoomGiftDiamond',
  multiRoomMicAgree: 'multiRoomMicAgree',

  /*----------------------- lucky bag ---------------------------*/

  // 房间红包创建
  roomLuckyBagCreate: 'roomLuckyBagCreate',
  // 房间红包创建全服
  roomLuckyBagWholeServer: 'roomLuckyBagWholeServer',
  // 房间红包销毁
  roomLuckyBagDestroy: 'roomLuckyBagDestroy',

  /*-------------------- 语音房魅力值通知 ---------------------------*/
  roomMicCharmPush: 'roomMicCharmPush',

  /*-------------------匹配------------------*/
  matchSuccess: 'call',

  //主播任务
  roomTreasureBox: 'roomTreasureBox',

  // 房间更新麦位样式
  roomLevelMicStyleChange: 'roomLevelMicStyleChange'
}
